import { useEffect, useState } from "react";
import { apiBase } from "../Reviews/api";
export type PublicConfig = {
  beta?: {
    enabled: boolean;
    feeMode: string;
    models: string[];
    publicSharing: boolean;
  };
  auth?: { signup_mode: string };
  reviews?: { price_cents: number; turnaround_hours: number };
  policies?: { version: string; hash: string };
};
export function usePublicConfig() {
  const [config, setConfig] = useState<PublicConfig | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    Promise.resolve()
      .then(() => fetch(`${apiBase}/api/config`, { signal: controller.signal }))
      .then(r => {
        if (!r.ok) throw Error("Unavailable");
        return r.json();
      })
      .then(setConfig)
      .catch(() => {});
    return () => controller.abort();
  }, []);
  return config;
}
